import { render, staticRenderFns } from "./QTHDistributionProofing.vue?vue&type=template&id=c96d7c7a"
import script from "./QTHDistributionProofing.vue?vue&type=script&lang=js"
export * from "./QTHDistributionProofing.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports